export class CriterionDetailsDialogViewModel
{
    isOpen = false;

    name = '';
    path = '';
    description = '';

    show(name: string, path: string, description: string)
    {
        this.name = name;
        this.path = path;
        this.description = description ?? '';
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.name = '';
        this.path = '';
        this.description = '';
    }
}
